export const elementInListsWarning =
  "This recipe is in one or more of your lists. Are you sure you want to remove it from all lists?";
